import { statsSearchSchema } from "$/lib/stats-search"
import { createFileRoute, redirect } from "@tanstack/react-router"

/** Trender is part of Nyckeltal now; this keeps old links working. */
export const Route = createFileRoute("/(app)/_auth/trends")({
  validateSearch: statsSearchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/stats", search, replace: true })
  },
})
